import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { SharedService } from '../shared.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-step-buttons',
	templateUrl: './step-buttons.component.html',
	styleUrls: ['./step-buttons.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class StepButtonsComponent implements OnInit {

	@Input() showBackButton = false;
	@Input() hasCancel = true;
	@Input() sectionToBack: string;
	@Input() nextLabel = 'Continuar';
	@Input() disabled = false;
	@Output() onSendForm: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(public sharedService: SharedService, private router: Router) { }

	ngOnInit() {
	}

	sendForm(event) {
		this.onSendForm.emit(true);
	}

	goBack() {
		this.router.navigate([this.sectionToBack]);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/step-buttons/step-buttons.component.ts